import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

export const Route = createFileRoute("/(auth)/set-new-password")({
  validateSearch: z.object({
    token: z.string().optional(),
    email: z.string().optional(),
  }),
})
